import { styled } from '@mui/material';

export const StyledErrorPlaceholder = styled('span')({
	minHeight: '1rem',
});
